import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {InfoPageHeaderComponent} from '../../shared/components/info-page-header/info-page-header.component';
import {ReactiveFormsModule} from '@angular/forms';
import {Router, RouterLink} from '@angular/router';
import {HoomvipStorage} from '../../core/hoomvip-storage/hoomvip-storage.service';
import {MetricsService} from '../../core/services/metrics.service';

@Component({
  selector: 'app-check-in-end',
  templateUrl: './check-in-end.component.html',
  styleUrls: ['./check-in-end.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, InfoPageHeaderComponent, RouterLink],
})
export class CheckInEndComponent implements OnInit {
  hasContract = false;
  hasTravelRegister = false;
  contractUrl = '';
  travelRegisterFileURL = '';

  constructor(
    protected router: Router,
    protected hoomvipStorage: HoomvipStorage,
    protected metricsService: MetricsService,
  ) {
  }

  ngOnInit(): void {
    const nav = this.router.getCurrentNavigation();
    const state: any = nav?.extras?.state || history.state;

    this.hoomvipStorage.unmarkCheckingWarning();
    this.trackCheckInEnded();

    this.contractUrl = state?.['contractUrl'] || history.state?.contractUrl || this.hoomvipStorage.getSignedContractUrl();
    this.hasContract = !!this.contractUrl && this.contractUrl !== 'null';
    this.travelRegisterFileURL = state?.['travelRegisterFileURL'] || history.state?.travelRegisterFileURL || this.hoomvipStorage.getSignedTravelRegisterFileUrl();
    this.hasTravelRegister = !!this.travelRegisterFileURL;
  }

  protected trackCheckInEnded(): void {
    this.metricsService.checkInAdultEnded();
  }

  closeCheckIn(): void {
    this.hoomvipStorage.clearCheckInInfo();
    this.router.navigate(['/home']);
  }
}
